module.exports = __webpack_public_path__ + "media/images/category_icons/hobbies-92d1114e1f180b2bea9e0143168dd121.svg";